
// Pantomime-Kategorien
export const pantomimeCategories = [
  {
    name: "Tiere",
    items: [
      "Katze",
      "Hund",
      "Pinguin",
      "Känguru",
      "Giraffe",
      "Vogel",
      "Elefant",
      "Fisch",
      "Delfin",
      "Tiger",
      "Löwe",
      "Eule",
      "Bär",
      "Pferd",
      "Krokodil",
      "Schlange",
      "Nashorn",
      "Eichhörnchen",
      "Fledermaus",
      "Koala"
    ]
  },
  {
    name: "Fahrzeuge & Transport",
    items: [
      "Auto",
      "Fahrrad",
      "Hubschrauber",
      "Rakete",
      "Achterbahn",
      "Riesenrad",
      "Zug",
      "Motorrad",
      "Boot",
      "U-Bahn",
      "Traktor",
      "Heißluftballon",
      "Roller",
      "Segelschiff",
      "Gabelstapler",
      "Kutsche"
    ]
  },
  {
    name: "Gegenstände",
    items: [
      "Tisch",
      "Stuhl",
      "Lampe",
      "Telefon",
      "Buch",
      "Tür",
      "Haus",
      "Schuhe",
      "Blume",
      "Kamera",
      "Schlüssel",
      "Laptop",
      "Brille",
      "Fahne",
      "Regenschirm",
      "Schere",
      "Uhr",
      "Fernseher",
      "Geldbeutel",
      "Mikrofon"
    ]
  },
  {
    name: "Berufe",
    items: [
      "Astronaut",
      "Opernsänger",
      "Fernsehmoderator",
      "Tennisspieler",
      "Raketentechniker",
      "Schachmeister",
      "Brückenbau",
      "Formel-1-Fahrer",
      "Uhrmacher",
      "Pilot",
      "Koch",
      "Lehrer",
      "Friseur",
      "Polizist",
      "Feuerwehrmann",
      "Bäcker",
      "Bauarbeiter",
      "Tierarzt",
      "Zirkusartist",
      "Detektiv"
    ]
  },
  {
    name: "Aktionen",
    items: [
      "Drachenfliegen",
      "Fechten",
      "Fallschirmspringen",
      "Skateboard fahren",
      "Schlittschuhlaufen",
      "Bergsteiger",
      "Taucher",
      "Popcorn essen",
      "Seilspringen",
      "Fahrrad fahren",
      "Gitarre spielen",
      "Yoga machen",
      "Handstand",
      "Kanu fahren",
      "Autofahren",
      "Zaubern",
      "Tanzen",
      "Springseil springen",
      "Gewichte heben",
      "Basketball spielen"
    ]
  }
];

// Zufallsereignisse
export const randomEvents = [
  {
    text: "Glückwunsch! Du darfst 3 Schlücke verteilen!",
    action: (player, updateScore) => updateScore(player, 1, 0),
    type: "positive"
  },
  // ... weitere Ereignisse
];

// Regeln
export const predefinedRules = {
  global: [
    "Trinkt nur mit der schwachen Hand",
    "Sagt 'Prost' vor jedem Schluck",
    "Keine Getränke auf den Tisch stellen",
    "Zeigt immer auf jemanden, bevor du trinkst",
    "Sprecht in der dritten Person",
    "Verwendet 'ODER?' am Ende jedes Satzes",
    "Sagt 'Danke' nach jedem Schluck",
    "Niemand darf das Wort 'trinken' sagen",
    "Jeder muss nach einem Schluck ein Tiergeräusch machen",
    "Vermeide Augenkontakt mit anderen – falls doch, trinke!",
    "Niemand darf 'ich' sagen",
    "Wer aufsteht, muss einen Schluck nehmen",
    "Niemand darf mit seinem eigenen Namen angesprochen werden",
    "Keine Beleidigungen erlaubt"
  ],
  personal: [
    "{player} muss jedes Mal einen Schluck trinken, wenn jemand lacht",
    "{player} darf nur noch flüstern",
    "{player} muss jedes Mal aufstehen zum Trinken",
    "{player} muss vor jedem Trinken eine Pirouette drehen",
    "{player} muss jedes Mal 'Ich bin ein Einhorn' sagen bevor er/sie trinkt",
    "{player} muss beim Trinken den kleinen Finger abspreizen",
    "{player} muss vor jedem Schluck eine Pose machen",
    "{player} darf nur noch in Reimen sprechen",
    "{player} muss nach jedem Schluck applaudieren",
    "{player} muss jedes Mal miauen, wenn jemand seinen Namen sagt",
    "{player} muss jedes Mal 'Ich liebe dieses Spiel' sagen, bevor er/sie trinkt",
    "{player} darf nur noch in Fragen sprechen",
    "{player} muss jedes Mal, bevor er/sie trinkt, eine unsichtbare Krawatte richten"
  ]
};

// Zeichenkategorien
export const drawingCategories = [
  {
    name: "Bekannte Filme",
    items: [
      "Interstellar",
      "Inception",
      "The Wolf of Wall Street",
      "Forrest Gump",
      "Star Wars",
      "Der Herr der Ringe",
      "Der Hobbit",
      "Oben",
      "Die Tribute von Panem",
      "WALL-E",
      "Der König der Löwen",
      "Dune",
      "Avatar",
      "Titanic",
      "Jurassic World",
      "Avengers",
      "Fast & Furious",
      "Die Eiskönigin",
      "Harry Potter",
      "Die Schöne und das Biest",
      "Iron Man",
      "Minions",
      "Spider-Man",
      "James Bond",
      "Transformers",
      "The Dark Knight",
      "Joker",
      "Toy Story",
      "Fluch der Karibik",
      "Ich - Einfach unverbesserlich",
      "Zoomania",
      "Dschungelbuch",
      "Findet Nemo",
      "Jumanji",
      "Shrek",
      "Bohemian Rhapsody",
      "Ice Age",
      "Guardians of the Galaxy",
      "Alles steht Kopf",
      "Venom",
      "Independence Day",
      "E.T.",
      "Mission: Impossible",
      "Indiana Jones",
      "Deadpool",
      "Pulp Fiction",
      "Blade Runner",
      "Casablanca",
      "Fight Club",
      "Der Pate",
      "Matrix",
      "Dirty Dancing",
      "Alien",
      "The Shining",
      "Das Schweigen der Lämmer",
      "Zurück in die Zukunft",
      "Der Weiße Hai",
      "Ghostbusters",
      "Ziemlich beste Freunde",
      "American Psycho",
      "Rocky",
      "Terminator",
      "Gladiator",
      "Der Zauberer von Oz",
      "Chihiros Reise ins Zauberland"
    ]
  },
  {
    name: "Essen und Trinken",
    items: [
      "Pommes",
      "Burger",
      "Pizza",
      "Nudeln",
      "Karotten",
      "Speck",
      "Fleisch",
      "Chicken Nuggets",
      "Gemüse",
      "Obst",
      "Melone",
      "Schinken",
      "Brot",
      "Orangen",
      "Äpfel",
      "Kartoffeln",
      "Croissant",
      "Milchreis",
      "Reis",
      "Sushi",
      "Salat",
      "Birnen",
      "Blaubeeren",
      "Erdbeeren",
      "Bananen",
      "Eier",
      "Döner",
      "Süßigkeiten",
      "Schokolade",
      "Chips",
      "Kürbis",
      "Mango",
      "Honig",
      "Apfelsaft",
      "Cola",
      "Wasser",
      "Orangensaft",
      "Milch",
      "Alkohol",
      "Hähnchen",
      "Schweinefleisch",
      "Rindfleisch",
      "Burrito",
      "Rührei",
      "Eiscreme",
      "Kuchen",
      "Muffin",
      "Kekse",
      "Waffeln",
      "Frühstück",
      "Mittagessen",
      "Abendessen",
      "Vegetarisch",
      "Vegan",
      "Bratwurst",
      "Currywurst",
      "Joghurt",
      "Pflaumen",
      "Oliven",
      "Bier",
      "Wein",
      "Sauerkraut",
      "Truthahn",
      "Spätzle"
    ]
  },
  {
    name: "Sommerzeit",
    items: [
      "Beach Volleyball",
      "Schwimmen",
      "Sonnenschein",
      "Sonnencreme",
      "Road Trip",
      "Ferien",
      "Camping",
      "Kanu",
      "Wassermelone",
      "Ananas",
      "Mango",
      "Wandern",
      "Sonnenbrille",
      "Frisbee",
      "Eis",
      "Picknick",
      "Sandburg",
      "Sandalen",
      "Wasserpark",
      "Barbeque",
      "Surfen",
      "Golf",
      "Eis am Stiel",
      "Kokosnusswasser",
      "Lagerfeuer",
      "Palme",
      "Sonne",
      "Tourist",
      "Sehenswürdigkeit",
      "Taucherbrille",
      "Badeanzug",
      "Eiswagen",
      "Limonade",
      "Bootfahren",
      "Maiskolben",
      "Marshmallow",
      "Hamburger",
      "Hot Dogs",
      "Baseball",
      "Fußball",
      "Tauchen",
      "Jetski",
      "Feuerwerk",
      "Angeln",
      "Freizeitpark",
      "Sonnenblume",
      "Sonnenhut",
      "Radfahren",
      "Spielplatz",
      "Hängematte",
      "Kino",
      "Drachen",
      "Heißluftballon",
      "Delfin",
      "Wasserballonschlacht"
    ]
  },
  {
    name: "Rund um die Schule",
    items: [
      "Schule",
      "Schulgebäude",
      "Klassenzimmer",
      "Lehrer",
      "Schüler",
      "Hausmeister",
      "Sport",
      "Mathe",
      "Deutsch",
      "Englisch",
      "Geschichte",
      "Biologie",
      "Chemie",
      "Physik",
      "Musik",
      "Kunst",
      "Politik",
      "Erdkunde",
      "Grundschule",
      "Gymnasium",
      "Realschule",
      "Einschulung",
      "Hausaufgaben",
      "Klassenfahrt",
      "Kantine",
      "Federmappe",
      "Füller",
      "Kugelschreiber",
      "Bleistifte",
      "Buntstifte",
      "Geodreieck",
      "Lineal",
      "Schulhof",
      "Pausenbrot",
      "Spielplatz",
      "Schulverweis",
      "Zeugnisse",
      "Nachsitzen",
      "Klassenclown",
      "Overheadprojektor",
      "Rucksack",
      "Schulranzen",
      "Taschenrechner",
      "Schulheft",
      "Vokabeln",
      "Sporthalle",
      "Computerräume",
      "Tafel",
      "Kreide",
      "Holzstühle",
      "Tische",
      "Schultoilette"
    ]
  },
  {
    name: "Weihnachtszeit",
    items: [
      "Advent",
      "Adventskalender",
      "Adventskranz",
      "All I Want For Christmas Is You",
      "Bescherung",
      "Christbaumkugel",
      "Christkind",
      "Dezember",
      "Heiligabend",
      "Kerze",
      "Knecht Ruprecht",
      "Krampus",
      "Krippenspiel",
      "Lametta",
      "Last Christmas",
      "Lebkuchen",
      "Mandel",
      "Mistelzweig",
      "Schnee",
      "Silvester",
      "Spekulatius",
      "Vanillekipferl",
      "Weihnachtsbäckerei",
      "Weihnachtsbaum",
      "Weihnachtsbeleuchtung",
      "Weihnachtsferien",
      "Weihnachtsmann",
      "Weihnachtsmarkt",
      "Wichteln",
      "Wunschzettel",
      "Zimtstern"
    ]
  }
];
